<template>
    <div class="features-page">
        <HeaderLanding mode="light" />
        
            <section class="features-section">
                <div class="features-container">
                    <!-- Badge -->
                    <div class="badge-box">
                        <img src="@/assets/img/codesandbox.png" alt="codesandbox" class="codesandbox-icon" />
                        <span class="badge-text">SurPriz.ing</span>
                    </div>
                    <h1 class="features-title">Keep customers coming back <br class="desktop-break"/>simple & automatic!</h1>

                    <section class= "features-content">
                        <div class="features-col1">
                            <h1>Mobile Friendly</h1>
                            <h2 class="features-subtitle">Everything You Need to Keep Customers Coming Back</h2>
                            <div class="image-wrapper">
                                <img src="@/assets/img/mockup-phone.png" alt="Phone Mockup" class="mockup-phone" />
                            </div>
                        </div>

                        <div class="features-col2">
                            <div class="features-card1">
                                <div class="highlight">
                                <div class="container">
                                    <div class="profiles">
                                        <div class="profile-img-wrapper" style="background-color: #D946EF">
                                            <img class="profile-img" src="@/assets/img/FeaturePic1.png" alt="Profile 1" />
                                        </div>
                                        <div class="profile-img-wrapper" style="background-color: #4991FE">
                                            <img class="profile-img overlapped" src="@/assets/img/FeaturePic2.png" alt="Profile 2" />
                                        </div>
                                        <div class="profile-img-wrapper" style="background-color: #58DCC5">
                                            <img class="profile-img overlapped" src="@/assets/img/FeaturePic3.png" alt="Profile 3" />
                                        </div>
                                        <div class="profile-plus-wrapper" style="background-color: #DDE3EE">
                                            <div class="profile-img-wrapper overlapped plus-wrapper" >+</div>
                                        </div>
                                        
                                    <!-- <img class="profile-img overlapped" src="@/assets/img/plus-icon.svg" alt="Add More" /> -->
                                    </div>
                                    <h3 class="title">Features That Make Loyalty Simple</h3>
                                </div>
                                </div>
                            </div>
                            <div class="features-card2">
                                <img src="@/assets/img/element1.png" alt="element 1" />
                                <h2 class="features-card-title">2X</h2>
                                <img src="@/assets/img/element2.png" alt="element 2" />
                                <p class="features-card-subtitle">A simple way to gather feedback, offer rewards, and build customer loyalty</p>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <section class="features">
                <div class="container2">
                    <div class="label">
                        <div class="faq">FEATURES</div>
                    </div>
                    <div class="yourSmartLoyalty">Your Smart Loyalty & Feedback Toolkit</div>
                    <div class="everythingYouNeed">
                        Everything you need to turn every visit into repeat business — with AI insights, instant rewards, and seamless engagement
                    </div>

                    <div class="products">
                    <!-- Feature 1 -->
                    <div class="feature1">
                        <div class="text1">
                        <div class="easyFeedback">Easy Feedback & Rewards</div>
                        <div class="customersScanA">
                            Customers scan a QR code after their visit is approved by the cashier — they answer a quick survey and instantly receive e-vouchers or points as rewards. No app download needed, just simple, fast engagement.
                        </div>
                        </div>
                        <img class="dashboardIcon" src="@/assets/img/DashboardFeedback.png" alt="Feedback Dashboard" />
                    </div>

                    <!-- Feature 2 -->
                    <div class="feature2">
                        <div class="text1">
                        <div class="easyFeedback">Smart Insights & Custom Rules</div>
                        <div class="customersScanA">
                            Our AI analyzes every piece of feedback, turning it into actionable insights you can use to improve services and keep customers happy. Set your own rules for vouchers and points to match your business goals.
                        </div>
                        </div>
                        <img class="dashboardIcon" src="@/assets/img/DashboardInsight.png" alt="Insight Dashboard" />
                    </div>

                    <!-- Feature 3 -->
                    <div class="feature3">
                        <div class="text1">
                        <div class="easyFeedback">Seamless Growth Tools</div>
                        <div class="customersScanA">
                            Expand your reach with multi-language support and an easy referral system that lets happy customers share your brand with friends. SurPriz.ing also integrates smoothly with POS and CRM tools for a hassle-free experience.
                        </div>
                        </div>
                        <img class="dashboardIcon2" src="@/assets/img/DashboardReward.png" alt="Rewards Dashboard" />
                    </div>
                    </div>
            </div>
        </section>
        <FooterLanding />
    </div>
</template>

<script>
import HeaderLanding from '@/components/HeaderLanding.vue';
import FooterLanding from '@/components/FooterLanding.vue';

export default {
    name: 'AboutUs',
    components: {
        HeaderLanding,
        FooterLanding,
    },
};
</script>

<style scoped>
.features-page {
    background-color: #FFFFFF;
    box-sizing: border-box;
    min-height: 100vh;
    overflow-x: hidden;
    font-family: 'Inter', sans-serif;
}

.features-section {
    background-color: #ffffff; /* full width white */
    padding: 96px 120px;
    text-align: center;
}
.features-container {
    gap: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Badge Box */
.badge-box {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px 8px 8px;
  background-color: #fff;
  border: 1px solid #dfe1e6;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
  font-size: 14px;
  font-weight: 500;
  color: #808897;
}
.codesandbox-icon {
  width: 20px;
  height: 20px;
}

.features-title {
    font-family: Inter, sans-serif;
    font-size: 48px;
    font-weight: 600;
    color: #171717;
    line-height: 120%;
}


/* This wrapper controls the visible "box" (crops the image) */
.image-wrapper {
    width: 471px;
    height: 533px;
    overflow: hidden;
    position: relative;
    padding: 31px;
}


.mockup-phone {
  width: 100%;
  max-width: 790px;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}



.features-content {
  display: flex;
  gap: 40px;
  margin-top: 48px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap; /* for responsive */
}

.features-col1 {
  position: relative;
  background-color: #5348E7;
  background-image: url('~@/assets/img/feature-gridbg.png');
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 24px;
  padding: 48px 48px 0 48px;
  flex: 1;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
    height: 688px;
    width: 790px;
    flex: 0 0 auto;
}
.features-col1 h1 {
  font-size: 48px;
  font-weight: 600;
    margin: 31px 0 17px 0;
  /* margin-bottom: 16px; */
  line-height: 120%;
  color: white;
}
.features-col1 h2 {
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  color: white;
  opacity: 0.85;
}
.features-col1 img {
  max-width: 100%;
  border-radius: 32px;
  border: 13px solid white;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}


.features-col2 {
  flex: 1;
  min-width: 300px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Card 1 */
.features-card1 {
    width: 379px;
    height: 328px;
  background-color: #F3EBFF;
  border-radius: 16px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  position: relative;
  width: 288px;
  height: 226px;
  padding-top: 70px;
  padding-left: 46px;
}

.profiles {
  position: absolute;
  top: 0;
  left: 27px;
  display: flex;
  align-items: center;
      margin-top: 29px;
}

.profile-img-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 4px white;
  flex-shrink: 0;
}

.profile-plus-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 999px;
  /* background-color: white; */
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 8px #DDE3EE;
  flex-shrink: 0;/* to center the plus sign vertically */
}

.profile-img {
  width: 60px;
  height: 60px;
  border-radius: 999px;
  object-fit: cover;
}

.plus-wrapper {
  font-size: 60px;
  font-weight: 300;
  color: #99ABCC;
  text-align: center;
  line-height: 64px; /* vertically center text */
    padding-bottom: 12px; 
}


.title {
  color: #0171FF;
  font-size: 32px;
  font-weight: 500;
  line-height: 120%;
  text-align: center;
  margin-top: 64px;
    margin-left: -25px;
}

.features-card2 {
  position: relative;
  background: linear-gradient(150.53deg, #c69dff, #6587ff);
    padding: 44px 51px 74px 52px;
  border-radius: 16px;
  text-align: center;
    height: 328px;
    width: 379px;
  color: white;
  font-family: 'Manrope', sans-serif;
  overflow: hidden;
}

/* Position elements */
.features-card2 img:first-of-type {
    position: absolute;
    top: 46px;
    left: 80px;
    width: 56px;
    height: 132px;
  object-fit: contain;
}

.features-card2 img:last-of-type {
    position: absolute;
    top: 68px;
    right: 72px;
    width: 74px;
    height: 87px;
  object-fit: contain;
}

.features-card2 .features-card-title {
  font-size: 80px;
  font-weight: 500;
  margin-top: 32px;
  margin-bottom: 12px;
  line-height: 1;
}

.features-card2 .features-card-subtitle {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  max-width: 90%;
  margin: 24px;
}



.features {
  padding: 80px 0;
  background-color: #f8f8f8;
  text-align: center;
}

.container2 {
  max-width: 1200px;
  min-height: 500px;
  margin: 0 auto;
  padding: 0 16px;
}

.label .faq {
  color: #0171FF;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 8px;
  line-height: 150%;
}

.yourSmartLoyalty {
  font-size: 56px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
}

.everythingYouNeed {
  font-size: 16px;
    font-weight: 500;
  color: #5D6063;
}

.products {
  display: flex;
  flex-direction: column;
  gap: 64px;
  padding: 40px
}

.feature1{
      background: #4F44E3;
  border-radius: 16px;
    padding: 56px 48px 0;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.feature2{
      background: #8755DC;
  border-radius: 16px;
    padding: 56px 48px 0;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.feature3 {
  background: #473FB0;
  border-radius: 16px;
    padding: 56px 48px 0;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text1 {
  max-width: 720px;
  text-align: center;
  margin-bottom: 24px;
}

.easyFeedback {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 16px;
  line-height: 120%;
}

.customersScanA {
  font-size: 13px;
  line-height: 1.6;
  font-weight: 400;
    margin-bottom: 72px;
}

.dashboardIcon,
.dashboardIcon2 {
  width: 100%;
  max-width: 720px;
  height: auto;
  /* border-radius: 8px; */
}
.desktop-break {
  display: inline;
}


@media (max-width: 768px) {


  .desktop-break {
    display: none;  
  }
  .features-section {
    padding: 20px 24px;
  }
  
  .features-title{
    font-size: 28px;
    font-weight: 600;
  }

}

/* === FLUID SHRINK — TABLET/LAPTOP ONLY (desktop untouched) === */
@media (max-width: 1370px) {
  /* section paddings + title just shrink a bit */
  .features-section { padding: clamp(48px, 8vw, 96px) clamp(24px, 6vw, 120px); }
  .features-title   { font-size: clamp(28px, 5vw, 48px); line-height: 120%; }

  /* keep same composition, just smaller */
  .features-content{
    display: grid; /* use grid for precise two columns */
    grid-template-columns: clamp(260px, 55vw, 790px) clamp(120px, 25vw, 379px);
    gap: clamp(16px, 3vw, 40px);
    justify-content: center;
    align-items: start;
  }

  /* left big card scales */
  .features-col1{
    width: 100%;
    height: clamp(360px, 45vw, 688px);
    border-radius: clamp(16px, 2vw, 24px);
    padding: clamp(24px, 3vw, 48px) clamp(24px, 3vw, 48px) 0;
  }
  .features-col1 h1 { font-size: clamp(20px, 4vw, 48px); }
  .features-col1 h2 { font-size: clamp(12px, 2vw, 20px); }

  /* phone wrapper scales with the card */
  .image-wrapper{
    width: clamp(220px, 60%, 471px);
    height: clamp(240px, 60%, 533px);
    padding: clamp(16px, 2vw, 31px);
    border-radius: clamp(20px, 2vw, 32px);
  }

  /* right column: stacked cards scale */
  .features-col2{
    display: grid;
    gap: clamp(16px, 2vw, 24px);
    grid-auto-rows: clamp(150px, 22vw, 328px);
  }
  .container {
    width: clamp(207px, 20vw, 226px);
    height: clamp(73px, 20vw, 153px);
    padding-top: clamp(40px, 9vw, 115px);
    padding-left: clamp(24px, 9vw, 46px);
  }
  .features-card1, .features-card2{
    width: clamp(120px, 25vw, 379px);
    height: auto;
    border-radius: clamp(16px, 2vw, 24px);
  }
  .features-card1 .profile-img-wrapper{
    /* width: clamp(52px, 10vw, 26px);
    height: clamp(52px, 10vw, 26px); */
    width: clamp(35px, 6vw, 62px);
    height: clamp(35px, 6vw, 62px);

  }
  .features-card1 .profile-img {
    /* width: clamp(60px, 10vw, 64px);
    height: clamp(60px, 10vw, 64px); */
    /* width: clamp(44px, 9vw, 24px);
    height: clamp(45px, 9vw, 24px); */
    width: clamp(30px, 5vw, 95px);
    height: clamp(30px, 5vw, 95px);
  }
  .container .profiles{
    left: clamp(29px, 1vw, 23px) ;
  }
  .profile-plus-wrapper {
    width: clamp(35px, 2vw, 50px);
    height: clamp(35px, 2vw, 50px);
  }
  .plus-wrapper {
    font-size: clamp(35px, 4vw, 45px);
    padding-bottom: clamp(6px, 1vw, 7px);
  }
  .features-card1 .title {
    font-size: clamp(9.7px, 1.5vw, 16px);
    margin-top: clamp(31px, 2vw, 20px);
  }
  .features-card2 {
    padding: clamp(5px, 2vw, 0px);
  }

  .title { font-size: clamp(16px, 3.2vw, 32px); }
  .features-card2 .features-card-title    { font-size: clamp(10px, 5.5vw, 70px); margin-top: clamp(20px, 3vw, 32px); line-height: 1; }
  .features-card2 .features-card-subtitle { font-size: clamp(9px, 9.8vw, 11px); margin: clamp(2px, 2vw, 8px);; line-height: 1.5; }

  .features-card2 img:first-of-type {
    position: absolute;
    top: clamp(17px, 4.2vw, 101px);
    left: clamp(23px, 4vw, 123px);
    width: clamp(8px, 6.4vw, 87px);
    height: clamp(12px, 4.4vw, 114px);
  }
  .features-card2 img:last-of-type {
    position: absolute;
    top: clamp(17px, 4.2vw, 101px);
    right: clamp(23px, 4vw, 123px);
    width: clamp(8px, 6.4vw, 87px);
    height: clamp(12px, 4.4vw, 114px);
  }
  .feature1, .feature2, .feature3 {
    padding: clamp(24px, 4vw, 56px) clamp(24px, 4vw, 48px) 0;
    border-radius: clamp(12px, 2vw, 16px);
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .text1 {
    margin-bottom: clamp(6px, 2vw, 24px);
  }

  .yourSmartLoyalty {
    font-size: clamp(28px, 5vw, 56px);
    margin-bottom: clamp(16px, 2vw, 16px);
  }
  .everythingYouNeed {
    font-size: clamp(14px, 2.5vw, 16px);
    margin-bottom: clamp(24px, 3vw, 24px);
  }
  .easyFeedback {
    font-size: clamp(14px, 2.5vw, 48px);
    margin-bottom: clamp(8px, 1.5vw, 16px);
  }
  .customersScanA {
    font-size: clamp(4px, 1.2vw, 13px);
    margin-bottom: clamp(16px, 2vw, 72px);
  }
  .dashboardIcon, .dashboardIcon2 {
    width: 100%;
    max-width: clamp(200px, 50vw, 720px);
    height: auto;
  }


}



/* === PHONE SNAP (≤480px) — exact 425px-style composition === */
@media (max-width: 500px) {
  .features-section { padding: 32px 24px; }
  .features-title   { font-size: 28px; line-height: 1.2; }

  .features-content{
    grid-template-columns: 235px 114px; /* left / right */
    gap: 16px;
  }

  .features-col1{
    height: 208px;
    width: 239px;
    padding: 24px 24px 0;
    border-radius: 16px;
  }

  .features-col1 h1 { font-size: 14.55px; margin: 10px 0 10px; line-height: 1.2; }
  .features-col1 h2 { font-size: 6.06px; }

  .features-col1 img {
    border: 3px solid white;
    border-radius: 7.27px;
  }

  .image-wrapper { width: 142px; height: 250px; padding: 16px; border-radius: 10px; }
  .mockup-phone  { width: 100%; height: auto; }

  .features-col2{
    grid-auto-rows: 95px; /* height for each small card */
    gap: 16px;
  }
  .features-card1, .features-card2{
    width: 114px; height: 99px; border-radius: 16px;
  }
  .features-card1 .title{
    font-size: clamp(9px, 2.2vw, 14px);
    margin-top: clamp(50px, 5vw, 36px);
    padding: clamp(6px, 2vw, 8px);
  }
  .features-card2 {
    padding: 9px 9px 9px 9px;
  }
  .title{ font-size: 16px; margin: 12px 0 0; }
  .features-card2 .features-card-title{ font-size: 24px; margin-top: 5px; line-height: 1; }
  .features-card2 .features-card-subtitle{ font-size: 6px; line-height: 1.45; margin: 5px; }

  .features-card2 img:first-of-type {
    position: absolute;
    top: 16px;
    left: 20px;
    width: 15px;
    height: 21px;
  }
  .features-card2 img:last-of-type {
    position: absolute;
    top: 16px;
    right: 20px;
    width: 15px;
    height: 21px;
  }

  .container {
    padding: 22px 16px;
    width: 154px;
    height: 141px;
  }
  .container2 {
    max-width: 100%;
    padding: 0 24px;
  }
  .products {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 0;
  }
  .features-card1 .profile-img-wrapper {
    width: 22px; height: 22px;
    box-shadow: 0 0 0 2px white;
  }
  .features-card1 .profile-img {
    width: 20px; height: 20px; 
  } 
  .profiles {
    left: 32px;
    top: 12px;
  }
  .profile-plus-wrapper {
    width: 22px; height: 22px;
    box-shadow: 0 0 0 5px #DDE3EE;
  }
  .plus-wrapper {
    font-size: 37px;
    font-weight: 400;
    padding-bottom: 7px;
  }
  .yourSmartLoyalty {
    font-size: 28px;
  }
  .everythingYouNeed {
    font-size: 14px;
    margin-bottom: 24px;
  }
  .easyFeedback{
    font-size: 14px;
    margin-bottom: 8px;
  }
  .customersScanA {
    font-size: 4px;
    line-height: 1.45;
    margin-bottom: 22px;
  }
  .dashboardIcon, .dashboardIcon2 {
    width: 100%;
    max-width: 218px;
    height: auto;
  }



}




</style>